export default __webpack_public_path__ + "static/media/cover img.d94a08b5.jpg";